// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyASAPtGM5lxfGiIGhOI27G58kkgangtoKI",
  authDomain: "g-unit-fitness.firebaseapp.com",
  projectId: "g-unit-fitness",
  storageBucket: "g-unit-fitness.firebasestorage.app",
  messagingSenderId: "951141152211",
  appId: "1:951141152211:web:9ee008e796dbad2533ab26",
  measurementId: "G-B4BXB9SFTR"
};

// Initialize Firebase
const app = initializeApp(process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true'
  ? { ...firebaseConfig, projectId: 'demo-g-unitfitness', authDomain: 'localhost' }
  : firebaseConfig);
export default app;
